import type { ServiceQueryResultWithFetch } from '@atlassian/jira-software-deployments-service-query-types/src/services/types.tsx';
import type { DateRange } from '../../common/types.tsx';
import { getMaybeCombinedError } from '../../common/utils/errors.tsx';
import { useReportCoreData } from '../deployment-frequency-core/index.tsx';
import { usePerDeploymentMetrics } from '../per-deployment-metrics/index.tsx';
import type { PeriodBreakdown } from './types.tsx';
import { transformData } from './utils.tsx';

export const usePeriodBreakdownMetrics = (
	selectedDateRange: DateRange | null,
): ServiceQueryResultWithFetch<PeriodBreakdown> => {
	const perDeploymentMetricsResult = usePerDeploymentMetrics(selectedDateRange);
	const reportCoreDataResult = useReportCoreData();
	const isLoading = perDeploymentMetricsResult.loading || reportCoreDataResult.loading;

	const resultBase = {
		loading: isLoading,
		error: getMaybeCombinedError([perDeploymentMetricsResult.error, reportCoreDataResult.error]),
		fetch: perDeploymentMetricsResult.fetch,
	};

	return {
		...resultBase,
		data:
			reportCoreDataResult.data == null ||
			perDeploymentMetricsResult.data == null ||
			selectedDateRange == null
				? undefined
				: transformData(
						perDeploymentMetricsResult.data,
						reportCoreDataResult.data,
						selectedDateRange,
					),
	};
};
